import wretch from 'wretch';

// API URL constants
export const AUTH_API_URL = '/authorization';

/** Singleton for base wretcher. Bearer token is added on login. */
export const fmhAPI = { base: wretch(process.env.REACT_APP_BASE_URL) };
